import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Offer from "@/pages/Offer";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/admin/AuthContext";
import ProtectedRoute from "@/admin/ProtectedRoute";
import AdminLayout from "@/admin/AdminLayout";
import Login from "@/admin/Login";
import Dashboard from "@/admin/pages/Dashboard";
import Inquiries from "@/admin/pages/Inquiries";
import Subscribers from "@/admin/pages/Subscribers";
import Offers from "@/admin/pages/Offers";
import HomepageContent from "@/admin/pages/HomepageContent";
import GalleryManager from "@/admin/pages/GalleryManager";
import FaqManager from "@/admin/pages/FaqManager";
import Users from "@/admin/pages/Users";
import Activity from "@/admin/pages/Activity";
import Analytics from "@/admin/pages/Analytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/offers/:slug" element={<Offer />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="inquiries" element={<ProtectedRoute section="inquiries"><Inquiries /></ProtectedRoute>} />
              <Route path="subscribers" element={<ProtectedRoute section="subscribers"><Subscribers /></ProtectedRoute>} />
              <Route path="offers" element={<ProtectedRoute section="offers"><Offers /></ProtectedRoute>} />
              <Route path="homepage" element={<ProtectedRoute section="content"><HomepageContent /></ProtectedRoute>} />
              <Route path="gallery" element={<ProtectedRoute section="gallery"><GalleryManager /></ProtectedRoute>} />
              <Route path="faqs" element={<ProtectedRoute section="faqs"><FaqManager /></ProtectedRoute>} />
              <Route path="analytics" element={<ProtectedRoute section="analytics"><Analytics /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute section="users"><Users /></ProtectedRoute>} />
              <Route path="activity" element={<ProtectedRoute section="activity"><Activity /></ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
